// @flow
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Disclaimer from './Disclaimer';

// Selectors
import { getDealerName } from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = state => ({
  dealerName: getDealerName(state)
});
export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(Disclaimer);



// WEBPACK FOOTER //
// ./src/components/atoms/Disclaimer/DisclaimerContainer.js